const allProducts = {};
const productRequests = {};
const bundleButton = document.querySelector("[data-action-add-bundle]");
const container = document.querySelector('#bundle-selector');
const submitBtn = document.querySelector('.product-form__submit');
const errorText = document.getElementById('bundle-warning');
let variants = null;
let selectionRequestId = 0;

const bundleMetafields = window._bundleMetafields || [];
window._bundlesObj = window.ArtekBundleData
  ? window.ArtekBundleData.assembleBundleMetafields(bundleMetafields)
  : window._bundlesObj || [];

const bundleObj = window._bundlesObj.find(
  (bundle) => bundle.handle === window._bundleHandle
);
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);

function formatNumber(number) {
  // Convert number to fixed-point notation with 2 decimal places
  let formattedNumber = number.toFixed(2);

  // Add thousands separators using toLocaleString()
  formattedNumber = formattedNumber.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  return formattedNumber;
}

function fromHTML(html, trim = true) {
  // Process the HTML string.
  html = trim ? html.trim() : html;
  if (!html) return null;

  // Then set up a new template element.
  const template = document.createElement("template");
  template.innerHTML = html;
  const result = template.content.children;

  // Then return either an HTMLElement or HTMLCollection,
  // based on whether the input HTML had one or more roots.
  if (result.length === 1) return result[0];
  return result;
}

function tableBuild(selectedBundle) {
  let price = 0.0;
  let tableRows = "";
  let isAvailable = (selectedBundle?.products?.length ?? 0) > 0;
  const bundleTable = document.querySelector("[data-bundle-table]");
  (selectedBundle?.products || []).forEach((item) => {
    const varIdArr = item.variantId.split("/");
    const variantId = parseInt(varIdArr.pop());
    const product = allProducts[item.productHandle];
    if (!product) {
      isAvailable = false;
      return;
    }

    const variant = product.variants.find(
      (v) => v.id === variantId
    );

    if (!variant) {
      isAvailable = false;
      return;
    }

    price += variant.price * item.quantity;
    const vPrice = formatNumber((variant.price * item.quantity) / 100);
    const sku = variant.sku || "sku";
    let title = "";
    if (product.variants.length > 1) {
      title = variant.title;
    }

    tableRows += `<tr>
          <td>${sku}</td>
          <td>${product.title}</td>
          <td>${title}</td>
          <td>$${vPrice}</td>
          <td>${item.quantity}</td>
        </tr>`;
  });

  if (isAvailable) {
    price = formatNumber((price / 100));
    const addInfo = (window.customerDetails.isB2B) ? '<span class="price-label">Your Wholesale Price:</span>' : '';
    document
      .querySelectorAll(".product__info-container [data-price-container]")
      .forEach((container) => {
        // Check if the label already exists in the container
        const existingLabel = container.querySelector('.price-label');
        if (existingLabel) {
          // If label exists, only update the text after it
          const textNode = Array.from(container.childNodes).find(node => node.nodeType === Node.TEXT_NODE);
          if (textNode) {
            textNode.textContent = `$${price}`;
          }
        } else {
          // If no label exists, set the full innerHTML
          container.innerHTML = `${addInfo} $${price}`;
        }
      });
    submitBtn.classList.remove('disabled');
    errorText.setAttribute('aria-hidden', 'true');
  } else {
    document
      .querySelectorAll(".product__info-container [data-price-container]")
      .forEach((container) => {
        // Check if the label already exists in the container
        const existingLabel = container.querySelector('.price-label');
        if (existingLabel) {
          // If label exists, only update the text after it
          const textNode = Array.from(container.childNodes).find(node => node.nodeType === Node.TEXT_NODE);
          if (textNode) {
            textNode.textContent = 'N/A';
          }
        } else {
          // If no label exists, set the full innerHTML
          container.innerHTML = `${addInfo} N/A`;
        }
      });
    submitBtn.classList.add('disabled');
    errorText.removeAttribute('aria-hidden');
  }

  bundleTable.querySelector("tbody").innerHTML = tableRows;
  return isAvailable;
}

addEventListener("DOMContentLoaded", function (event) {
  if (window._bundlesLoaded) {
    return;
  }
  window._bundlesLoaded = true;
  function handleize(str) {
    return str
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/(^-|-$)+/g, "");
  }
  
  var bundleHandle = window._bundleHandle;
  var bundlesObj = window._bundlesObj;

  const bundle = bundlesObj?.find((item) => item.handle === bundleHandle);

  if (bundle && bundle.selection) {
    container.style.opacity = 0.5;
    container.style.pointerEvents = "none";
    submitBtn.classList.add('disabled');
    errorText.setAttribute('aria-hidden', 'true');

    const optionMap = [...bundle.optionMap];
    optionMap.forEach((opt, i) => {
      opt._position = i;
    });

    optionMap.sort((a, b) => a.order - b.order);

    const optArr = [];

    optionMap.forEach((opt, index) => {
      const optSelect = `<div>
            <fieldset class="product-form__input bundle-option" data-option-pos="${opt._position + 1}"><legend class="form__label">Select a ${
              opt.name
            }</legend>${opt.values
        .map((optVal) => {
          return `<input type="radio" id="${handleize(opt.name)}-${
            optVal.id
          }" data-opt-id="${opt.key}" name="option-${opt.key}" value="${
            optVal.id
          }" data-option-position="${opt._position + 1}" data-bundle-option>
              <label for="${handleize(opt.name)}-${optVal.id}">
                ${optVal.name}
              </label>`;
        })
        .join("")}</fieldset>
          </div>`;

      optArr.push(optSelect);
    });

    const prodForm = document.querySelector("#bundle-selector");

    // const variantId = prodForm.dataset.varId;

    optArr.forEach((optObj) => {
      prodForm.append(fromHTML(optObj));
    });

    // modify variants object to work similar to a standard product variant object
    variants = Object.keys(bundle.selection).map(v => {
      const selObj = bundle.selection[v];

      let variant = { key: v, enabled: selObj.enabled };
      let options = v.split('_');

      options.map((option, index) => {
        return variant[`option${index + 1}`] = option.split('-')[1];
      })

      return variant;
    });
  }

  function loadProduct(handle) {
    if (allProducts[handle]) return Promise.resolve(allProducts[handle]);
    if (productRequests[handle]) return productRequests[handle];

    productRequests[handle] = fetch(window.Shopify.routes.root + "products/" + handle + ".js")
      .then((response) => {
        if (!response.ok) throw new Error(`Unable to load ${handle} (${response.status})`);
        return response.json();
      })
      .then((product) => {
        allProducts[handle] = product;
        return product;
      })
      .catch((error) => {
        delete productRequests[handle];
        throw error;
      });

    return productRequests[handle];
  }

  async function renderSelection(selectedBundle) {
    if (!selectedBundle?.products) {
      return tableBuild(selectedBundle);
    }

    const requestId = ++selectionRequestId;
    const handles = [...new Set(selectedBundle.products.map((product) => product.productHandle))];

    container.style.opacity = 0.5;
    container.style.pointerEvents = "none";
    submitBtn.classList.add('disabled');

    try {
      await Promise.all(handles.map(loadProduct));
    } catch (error) {
      console.error("Unable to load bundle pricing:", error);
    }

    if (requestId !== selectionRequestId) return;

    const isAvailable = tableBuild(selectedBundle);
    container.style.opacity = 1;
    container.style.pointerEvents = "auto";
    return isAvailable;
  }


  /**
  * Set the default variant
  */
  function setDefaultSelection() {
    let initialVariant = variants ? variants.find(v => v.enabled) : null;

    if (!container || !initialVariant) return;

    // get the variant options and set the inputs as checked
    for (const [key, value] of Object.entries(initialVariant)) {
      if (key.includes('option')) {
        let optionPosition = key.replace('option', '');
        let option = container.querySelector(
          `input[value^="${value}"][data-option-position="${optionPosition}"]`
        );
        if (!option) continue;
        let optionId = option.dataset.optId;

        bundleObj?.optionMap.find((opt) => {
          if (opt.key === Number(optionId)) {
            const paramValue = urlParams.get(opt.key);
            opt.values.find((value) => {
              if (value.id === Number(paramValue)) {
                option = container.querySelector(
                  `input[value^="${paramValue}"][data-option-position="${optionPosition}"]`
                );
                return true;
              }
            });
            return true;
          }
        });

        if (option) option.checked = true;
      }
    }

    disableUnavailableOptions();
  }

  function doDisableOption(selector, key, currentIds) {
    const selectorOpts = selector.querySelectorAll('input');
    selectorOpts.forEach(selectorOpt => {
      const selectorId = `${selectorOpt.dataset.optId}-${selectorOpt.value}`;
      const checkArr = [...currentIds];
      checkArr[key] = selectorId;

      const partKey = checkArr.slice(0, key + 1).join('_');

      const firstAvailable = Object.keys(bundle.selection).some((bundleKey) => {
        if (bundleKey.startsWith(partKey)) {
          return bundle.selection[bundleKey].enabled;
        }

        return false;
      });

      if (!firstAvailable) {
        selectorOpt.classList.add('disabled');
        selectorOpt.checked = false;
      }
    });

    const checkChecked = selector.querySelectorAll('input:checked');
    if (!checkChecked.length) {
      const firstNonDisabled = selector.querySelector('input:not(.disabled)');
      if (firstNonDisabled) {
        firstNonDisabled.checked = true;
      }
    }
  }

  /**
  * Set disabled class for unavailable options
  */
  function disableUnavailableOptions() {
    if (!bundle.optionMap) return;
    
    const allInputs = container.querySelectorAll('input[data-option-position]');
    allInputs.forEach(ip => ip.classList.remove('disabled'));

    let currentSelection = container.querySelectorAll('input[data-option-position]:checked');
    currentSelection = Array.from(currentSelection);
    currentSelection.sort((a, b) => a.dataset.optionPosition - b.dataset.optionPosition);

    let currentIds = Array.from(currentSelection).map(radio => `${radio.dataset.optId}-${radio.value}`);

    let bundleOptionSelectors = document.querySelectorAll('.bundle-option');
    bundleOptionSelectors = Array.from(bundleOptionSelectors).sort((a, b) => a.dataset.optionPos - b.dataset.optionPos);
    bundleOptionSelectors.forEach((selector, key) => {
      if (key == 0) {
        return;
      }
      doDisableOption(selector, key, currentIds);

      currentSelection = Array.from(currentSelection).sort((a, b) => a.dataset.optionPosition - b.dataset.optionPosition);
      currentIds = Array.from(currentSelection).map(radio => `${radio.dataset.optId}-${radio.value}`);
    });
  }


  /**
  * Handle variant selection
  */
  function handleSelectVariant() {
    if (!container) return;

    let options             = container.querySelectorAll('input[data-option-position]');
    let maxOptions          = bundle?.optionMap?.length;
    let selectedOptions     = {};

    if (maxOptions) {
      options.forEach(radio => {
        let position = radio.getAttribute('data-option-position');

        radio.addEventListener('change', async function(e) {
          selectedOptions = {};
          let radios = container.querySelectorAll('input[data-option-position]');

          // reset radios
          radios.forEach(radio => radio.classList.remove('disabled'));
          disableUnavailableOptions();

          // get the current selected variant options
          for (let index = 0; index < maxOptions; index++) {
            let position = index + 1;
            let option   = container.querySelector(`input[data-option-position="${position}"]:checked`);

            if (!option) break;

            selectedOptions[`option${position}`] = option.value;
          }

          // get the exact match for the current selection
          let exactMatch = variants.filter(v => {
            return Object.keys(selectedOptions).every(key => v[key] === selectedOptions[key]);
          });

          // get closely matching variant for when we don't have an exact match
          let matchingVariants = variants.filter(v => {
            return v[`option${position}`] == radio.value;
          });

          let match = exactMatch.length > 0 ? exactMatch[0] : matchingVariants[0];

          // loop over match and set imputs to checked
          if (match) {
            const isAvailable = await setSelectedVariant(match);

            if (isAvailable) {
              bundleButton.removeAttribute('disabled');
              bundleButton.innerText = 'Add Bundle';
            } else {
              bundleButton.setAttribute('disabled', '');
              bundleButton.innerText = 'Unavailable';
            }

          } else {
            bundleButton.setAttribute('disabled', '');
            bundleButton.innerText = 'Unavailable';
          };

        });

      })

    } else if (options?.length === 0 ) {
      bundleButton.setAttribute('disabled', '');
      bundleButton.innerText = 'Unavailable';
    }

  }

  /**
  * Set selected variant
  */
  async function setSelectedVariant(object) {
    if (!object) return;

    for (const [key, value] of Object.entries(object)) {
      if (key.includes('option')) {
        let position  = key.replace('option', '');
        let option = container.querySelector(
          `input[value^="${value}"][data-option-position="${position}"]`
        );
        let optionId = option.dataset.optId;

        if (window.history.pushState) {
          let newUrl = new URL(window.location.href);
          newUrl.searchParams.set(optionId, value);
          window.history.pushState({ path: newUrl.href }, '', newUrl.href);
        }

        if (option) option.checked = true;
      }
    }

    const selectedBundle = bundle.selection[object.key];

    return renderSelection(selectedBundle);
  }


  // Default for table.
  async function defaultTable() {
    const selectedId = Array.from(container.querySelectorAll('[data-bundle-option]:checked'))
      .sort((a, b) => a.dataset.optionPosition - b.dataset.optionPosition)
      .map((option) => `${option.dataset.optId}-${option.value}`)
      .join('_');
    const defaultSelection = bundle.selection[selectedId];

    await renderSelection(defaultSelection);
  }

  const cartElement =
    document.querySelector("cart-notification") ||
    document.querySelector("cart-drawer");
  
  bundleButton.addEventListener("click", function (e) {
    let selectors = document.querySelectorAll("[data-bundle-option]:checked");
    selectors = Array.from(selectors).sort((a, b) => a.dataset.optionPosition - b.dataset.optionPosition);

    const selectApp = [];
    selectors.forEach((sel) => {
      const id = sel.dataset.optId;
      const val = sel.value;
      selectApp.push(`${id}-${val}`);
    });
  
    const selectedId = selectApp.join("_");

    const selectedBundle = bundle.selection[selectedId];
    if (!selectedBundle) {
      alert('Please make a selection');
      return;
    }

    let formData = {
      items: [],
    };

    selectedBundle.products.forEach((item) => {
      const varIdArr = item.variantId.split("/");
      formData.items.push({
        quantity: item.quantity,
        id: parseInt(varIdArr.pop()),
      });
    });

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((response) => {
        const itemCount = response.items.length ?? 1;
        const renderObject = {
          key: `${bundleHandle}_key`,
          sections: {
            "cart-notification-product": `<div id="shopify-section-cart-notification-product" class="shopify-section"><div id="cart-notification-product-${bundleHandle}_key" class="cart-item"><div class="cart-notification-product__image global-media-settings">
            <img
              src="${window._bundleGhost.featured_image}"
              alt=""
              width="70"
              height="66"
              loading="lazy"
            >
          </div><div><p class="caption-with-letter-spacing light">ARTEK</p><h3 class="cart-notification-product__name h4">${window._bundleGhost.title}</h3>
          <dl></dl></div>
      </div></div>`,
            "cart-notification-button": `<div id="shopify-section-cart-notification-button" class="shopify-section">View cart (${itemCount})</div>`,
            "cart-icon-bubble": `<div id="shopify-section-cart-icon-bubble" class="shopify-section"><svg class="icon icon-cart"  aria-hidden="true"  focusable="false"  xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 40 40"  fill="none">  <path fill="currentColor" fill-rule="evenodd" d="M20.5 6.5a4.75 4.75 0 00-4.75 4.75v.56h-3.16l-.77 11.6a5 5 0 004.99 5.34h7.38a5 5 0 004.99-5.33l-.77-11.6h-3.16v-.57A4.75 4.75 0 0020.5 6.5zm3.75 5.31v-.56a3.75 3.75 0 10-7.5 0v.56h7.5zm-7.5 1h7.5v.56a3.75 3.75 0 11-7.5 0v-.56zm-1 0v.56a4.75 4.75 0 109.5 0v-.56h2.22l.71 10.67a4 4 0 01-3.99 4.27h-7.38a4 4 0 01-4-4.27l.72-10.67h2.22z"/></svg><span class="visually-hidden">Cart</span><div class="cart-count-bubble"><span aria-hidden="true">${itemCount}</span><span class="visually-hidden">${itemCount} item</span>  </div></div>`
          }
        };
        cartElement.renderContents(renderObject);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  });

  setDefaultSelection()
  handleSelectVariant();
  defaultTable();
});
